import { FC, SVGProps } from 'react';

const UpArrowIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#2d2d2d', size = 24, ...props }) => {
  return (
    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M0.666992 5.49935L1.60699 6.43935L5.33366 2.71935V10.8327H6.66699V2.71935L10.387 6.44602L11.3337 5.49935L6.00033 0.166016L0.666992 5.49935Z"
        fill="#3F906D"
      />
    </svg>
  );
};

export default UpArrowIcon;
